<template>
  <li
    v-if="member"
    class="members__item member mx-3 py-2"
    @click="onClickMember">
    <div class="d-flex align-items-center">
      <div>
        <img
          v-if="member.avatar"
          class="img-fluid rounded-circle member__img mr-3"
          :src="member.avatar">
        <p v-else>
          <MaterialIcon
            icon="person"
            class="member__icon mr-3" />
        </p>
      </div>
      <div class="flex-grow-1">
        <div
          class="d-flex justify-content-between align-items-baseline container">
          <div
            class="d-flex align-items-baseline member-text"
            :class="{'searched': isSearched}">
            <div
              v-if="isAdmin"
              class="mr-1">
              <strong> 
                {{ member.sortNo | prettySortNo }}
              </strong>
            </div>
            <div class="member__content">
              <p class="member__name">
                {{ member.name }}
              </p>
            </div>
            <p
              class="member__title">
              {{ member.position }}
            </p>
            <button
              v-if="isAdmin && !member.isActive"
              class="btn btn-interested btn-secondary btn--small ml-1">
              <span class="material-icons btn-interested-icon">
                not_interested
              </span>
              利用停止中
            </button>
          </div>
          <div class="members__item__suffix">
            <slot name="suffix" />
          </div>
        </div>
        <slot />
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isSearched: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickMember() {
      if (this.isAdmin){
        this.$router.push(`/admin/members/${this.member.id}/edit`, () => {})
      } else {
        this.$router.push(`/members/${this.member.id}`, () => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/members';
@import '@/assets/stylesheets/member';
.btn-interested{
    margin: 0 0 0 auto;
  }

.btn-interested-icon{
  font-size: 18px;
  display: inline-block;
  vertical-align: text-bottom;
}

.container {
  padding: 5px 0;
}

.member-text {
  width: 100%;
  margin-right: 10px;
  margin-left: -10px;
  border-radius: 5px;
  padding: 5px 10px;

  &.searched {
    background: $highlight;
  }
}

.member__title {
  margin-left: auto;
}
</style>